import { getAuthorizationUrl } from "./openConnect";
export const userKey = "poupatempo"; 

const openConnectClientId = process.env.VUE_APP_OPEN_CONNECT_CLIENT_ID;

export const urlOpenConnectId = getAuthorizationUrl(openConnectClientId);
